import { apiFetch } from '@/lib/api-fetch'

/**
 * Retries a browser request once only when no HTTP response was received.
 * Provider and server errors are returned to the caller without a retry.
 */
export async function fetchWithNetworkRetry(
  input: RequestInfo | URL,
  init?: RequestInit,
  retryDelayMs = 400,
): Promise<Response> {
  try {
    return await apiFetch(input, init)
  } catch (firstError) {
    if (init?.signal?.aborted) throw firstError
    if (retryDelayMs > 0) await new Promise((resolve) => window.setTimeout(resolve, retryDelayMs))
    return apiFetch(input, init)
  }
}
